var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.matter_base_id)?[_c('Instructional',{staticClass:"px-1",attrs:{"matter_base_id":_vm.matter_base_id,"highlight_activity_id":_vm.highlight_activity_id,"allows_crud":_vm.allows_crud,"can_delete":_vm.can_delete,"can_update":_vm.can_update}})]:[_vm._v(_vm._s(_vm.$t("reusable.common.errorOccurred")))]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }